let shouldPreserveScroll = false

export const disableScrollUpdateOnce = () => {
  shouldPreserveScroll = true
}

export const getScrollUpdate = () => {
  if (shouldPreserveScroll) {
    shouldPreserveScroll = false

    return false
  }

  return true
}
